var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-empty',{attrs:{"image":"error"},scopedSlots:_vm._u([{key:"description",fn:function(){return [_c('p',[_vm._v("账户访问异常，请联系客服 "),_c('a',{attrs:{"href":"tel:4008812336"}},[_vm._v("400-8812-336")])])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }